window._define('tooltip', ['jquery', 'Modernizr'], function ($, modernizr) { 'use strict';
    var THRESHOLD = 4,
        tooltipCommonConf = {
            position: {
                my: 'left top+17',
                at: 'center-11 bottom',
                collision: 'flipfit',
            },
            tooltipClass: 'oc-tooltip',
            show: false,
            hide: false,
        },

        init = function () {
            var options = $.extend({}, tooltipCommonConf, {
                items: '.js-tooltip',
                content: setContent,
                open: onOpen,
            });

            if (!modernizr.touchevents) {
                $(document).tooltip(options);
            }
        },

        setContent = function () {
            var $element = $(this);
            return $element.data('tooltip') || $element.attr('title');
        },

        onOpen = function (event, ui) {
            var hpos = 'right',
                vpos = 'bottom',
                $target = $($(this).data('ui-tooltip').tooltips[ui.tooltip[0].id].element[0]), // get hovered element
                tooltipOffset,
                targetOffset;

            if ($target.width() > 300) {
                ui.tooltip.position({ my: 'left top+17', at: 'left bottom', of: $target });
            }

            tooltipOffset = ui.tooltip.offset();
            targetOffset = $target.offset();

            if ((targetOffset.left - tooltipOffset.left) > THRESHOLD) {
                hpos = 'left';
            }

            if ((targetOffset.top - tooltipOffset.top) > THRESHOLD) {
                vpos = 'top';
            }

            ui.tooltip.addClass('oc-tooltip--' + vpos + '-' + hpos);
        },

        addTooltipToElement = function (element, tooltipContent) {
            var $element = $(element),
                options = $.extend({}, tooltipCommonConf, {
                    content: setContent,
                    open: onOpen,
                });

            if (!modernizr.touchevents) {
                $element
                    .data('tooltip', tooltipContent)
                    .tooltip(options);
            }
        };

    return {
        init: init,
        add: addTooltipToElement,
    };

});
